import { useEffect, useState } from 'react';

import { api } from '../api/endpoints';
import type { EventCard } from '../api/types';
import { EventCardView } from '../components/EventCardView';

interface Props {
  onOpenEvent: (id: number) => void;
  onSeeAll: () => void;
}

export function HomePage({ onOpenEvent, onSeeAll }: Props) {
  const [mine, setMine] = useState<EventCard[] | null>(null);
  const [upcoming, setUpcoming] = useState<EventCard[] | null>(null);

  useEffect(() => {
    api.myEvents('upcoming').then(setMine).catch(() => setMine([]));
    api.events({ period: 'upcoming' }).then(setUpcoming).catch(() => setUpcoming([]));
  }, []);

  const mineIds = new Set((mine ?? []).map((e) => e.id));
  const others = (upcoming ?? []).filter((e) => !mineIds.has(e.id));

  return (
    <div className="screen">
      <header className="hero">
        <h1 className="hero__title">Место Силы</h1>
        <p className="hero__subtitle">Сообщество собственников бизнеса на Бали</p>
      </header>

      {mine && mine.length > 0 && (
        <section className="block">
          <h2 className="block__title">Вы идёте</h2>
          <div className="cards">
            {mine.map((event) => (
              <EventCardView key={event.id} event={event} onOpen={onOpenEvent} />
            ))}
          </div>
        </section>
      )}

      <section className="block">
        <div className="block__head">
          <h2 className="block__title">Ближайшие</h2>
          <button className="link" onClick={onSeeAll}>
            Все
          </button>
        </div>

        {upcoming === null ? (
          <div className="skeleton" />
        ) : others.length === 0 ? (
          <p className="muted">
            {mine && mine.length > 0
              ? 'Других ближайших мероприятий пока нет.'
              : 'Ближайших мероприятий пока нет. Загляните позже.'}
          </p>
        ) : (
          <div className="cards">
            {others.slice(0, 5).map((event) => (
              <EventCardView key={event.id} event={event} onOpen={onOpenEvent} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
